import React from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  return <div className="relative min-h-screen flex items-center overflow-hidden pt-20" data-id="element-173">
      {/* Video Background */}
      <div className="absolute inset-0 z-0" data-id="element-174">
        <div className="absolute inset-0 bg-black/30 z-10" data-id="element-175"></div>
        <video className="w-full h-full object-cover" autoPlay loop muted playsInline poster="https://images.unsplash.com/photo-1506929562872-bb421503ef21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2068&q=80" data-id="element-176">
          <source src="https://player.vimeo.com/external/370331493.sd.mp4?s=e90dcaba73c19e0e36f03406b47bbd6992dd6c1c&profile_id=139&oauth2_token_id=57447761" type="video/mp4" data-id="element-177" />
          Your browser does not support the video tag.
        </video>
      </div>
      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-178">
        <div className="max-w-3xl text-white" data-id="element-179">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-180">
            Work Without Walls
            <span className="block text-[#FF6B65]" data-id="element-181">Boardroom to the Beach</span>
          </h1>
          <p className="text-lg md:text-xl mb-8 text-white/90" data-id="element-182">
            Transform meetings into once-in-a-lifetime moments where ideas spark
            under palm trees and strategy sessions end with sunset toes-in-sand.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-183">
            <Button variant="primary" size="lg" to="/contact" data-id="element-184">
              Book a Discovery Call
            </Button>
            <Button variant="outline" size="lg" className="bg-white/10 border-white text-white hover:bg-white/20" to="/agenda" data-id="element-185">
              View Sample Agenda
            </Button>
          </div>
        </div>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce" data-id="element-186">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-187">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-188" />
        </svg>
      </div>
    </div>;
}